export default __webpack_public_path__ + "static/media/pin-question-fill.9314af71.svg";